import React from 'react';
import {
  AppstoreOutlined,
  FormOutlined,
  UserOutlined,
  LogoutOutlined,
  PushpinOutlined,
  CodeSandboxOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { IMenuItem } from '../types/menu';

/**
 * Base menu items for desktop navigation
 * These items will be shown to all authenticated users
 */
export const BASE_MENU_ITEMS: IMenuItem[] = [
  {
    key: '/',
    style: { fontWeight: '500' },
    label: 'Map',
  },
  {
    key: '/my-plans',
    label: 'My Plans',
  },
  {
    key: '/site-visit/list',
    label: 'Site Plans',
  },
];

/**
 * Admin menu item - will be added conditionally based on user role
 */
export const ADMIN_MENU_ITEM: IMenuItem = {
  key: '/admin',
  label: 'Admin',
};

export const CONTRACTOR_MENU_ITEM: IMenuItem = {
  key: '/contractor/proposals',
  label: 'Proposals',
};

/**
 * User menu items for the dropdown in desktop navigation
 */
export const USER_MENU_ITEMS: IMenuItem[] = [
  {
    key: '/user/profile',
    label: 'Profile',
  },
  {
    key: '/logout',
    icon: <LogoutOutlined style={{ marginRight: '5px' }} />,
    label: 'Logout',
  },
];

/**
 * Base mobile navigation items with icons
 * These items will be shown to all authenticated users in the bottom navigation
 */
export const MOBILE_NAV_ITEMS = [
  {
    key: '/',
    icon: <PushpinOutlined />,
    label: 'Map',
  },
  {
    key: '/my-plans',
    icon: <AppstoreOutlined />,
    label: 'My Plans',
  },
  {
    key: '/site-visit/list',
    icon: <FormOutlined />,
    label: 'Site Plans',
  },
];

/**
 * Admin mobile navigation item - will be added conditionally based on user role
 */
export const ADMIN_MOBILE_NAV_ITEM = {
  key: '/admin',
  icon: <CodeSandboxOutlined />,
  label: 'Admin',
};

export const CONTRACTOR_MOBILE_NAV_ITEM = {
  key: '/contractor/proposals',
  icon: <FileTextOutlined />,
  label: 'Proposals',
};

/**
 * Profile mobile navigation item - will be added to all users
 */
export const PROFILE_MOBILE_NAV_ITEM = {
  key: '/user/profile',
  icon: <UserOutlined />,
  label: 'Profile',
};

/**
 * Paths that should not display a footer
 */
export const EXCLUDE_FOOTER_PATHS = ['/', '/admin'];
